import { render, staticRenderFns } from "./btnUploadImg.vue?vue&type=template&id=7920ae45&scoped=true"
import script from "./btnUploadImg.vue?vue&type=script&lang=js"
export * from "./btnUploadImg.vue?vue&type=script&lang=js"
import style0 from "./btnUploadImg.vue?vue&type=style&index=0&id=7920ae45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7920ae45",
  null
  
)

export default component.exports